import api from './api';

const getProdutos = async () => {
  const { data } = await api.get('/produtos');
  return data;
};

const createProduto = async (produtoData) => {
  const { data } = await api.post('/produtos', produtoData);
  return data;
};

const updateProduto = async (id, produtoData) => {
  const { data } = await api.put(`/produtos/${id}`, produtoData);
  return data;
};

const deleteProduto = async (id) => {
  await api.delete(`/produtos/${id}`);
};

const produtoService = {
  getProdutos,
  createProduto,
  updateProduto,
  deleteProduto,
};

export default produtoService;